module.exports = __webpack_public_path__ + "static/media/c-live-vertical.81b91bb4.png";